<template>
  <a-breadcrumb :routes="filterRoute">
    <template slot="itemRender" slot-scope="{ route, routes }">
      <span v-if="notLink(routes, route)">
        {{route.meta.title}}
      </span>
      <span v-else>{{ route.meta.title }}</span>
<!--      <router-link v-else :to="route.path">-->
<!--        {{ route.meta.title }}-->
<!--      </router-link>-->
    </template>
  </a-breadcrumb>
</template>
<script>
import {TeacherSubject} from "@/config/typeConfig";
export default {
  name:'',
  data() {
    return {
      // basePath: '/components/breadcrumb',
      filterRoute: [],
    }
  },
  methods: {
    notLink(routes, route) {
      return (
        routes.indexOf(route) === routes.length - 1 ||
        route.meta.noBreadcrumbLink
      )
    },
  },
  mounted() {

  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const matchedRoute = this.$route.matched.map((r) => {
          const { meta, path} = r;
          if(path == '/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType'){
              meta.title = TeacherSubject[route.query.type];
            }
          return { meta, path }
        })
        const filterRoute =matchedRoute
        // if (this.$route.path !== '/dashboard') {
        //   //如果不是首页
        //   filterRoute.unshift({
        //     path: '/dashboard',
        //     meta: {
        //       title: 'dashboard',
        //     },
        //   })
        // }
        this.filterRoute = filterRoute

      },
    },
  },
}
</script>
<style lang="less">
.breadcrumb {
  z-index: 2;

}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue